import { getUserByRole, getUserRole } from "../../../../../Api/AdminApis";
import { useQuery } from "react-query";
import { BaseUrl } from "../../../../../Api/BaseUrl";

export const useRoleOptions = () => {
    const { data: roleList } = useQuery('roles', getUserRole);
  
    return roleList?.map((role: any) => ({
      value: role.id,
      label: role.name,
    })) || [];
  };

  export const useMembersByRole = (roleId: any, currentPage: any) => {
    return useQuery(['members', roleId, currentPage], () => getUserByRole(roleId, currentPage), {
      enabled: !!roleId,
    });
  };

  export const setCurrentPage = (navigate: Function, pageNo: any) => {
    const userRole = localStorage.getItem('ROLE');
    if (userRole === 'admin') {
      navigate(`/admin/memberrole-report/${pageNo}`);
    }else if (userRole === 'member') {
      navigate(`/member/memberrole-report/${pageNo}`);

    }
  };

  export const handleDownloadRoleMembers = (roleId: number, page: number = 1, limit: number = 20) => {
    const requestData = roleId !== null 
    ? {
        roleId,
        limit: 999999,
      }
    : {
        roleId: null,
        page,
        limit,
      };
  
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("AUTH_TOKEN") + "",
        "Content-Type": "application/json",
        responseType: "blob",
      },
      body: JSON.stringify(requestData),
    };
  
    fetch(`${BaseUrl}/exports/role-members`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to download the role members list.");
        }
        return response.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Members Roles.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
  
        return blob;
      })
      .catch((e) => {
        console.error("Error downloading role members list:", e);
      });
  };
  

export const handleDownloadClick = () => {}
